import { FC } from "react";
import { Checkbox } from "antd";
import { clsx } from "clsx";
import { TopicOption } from "../topicConfig";
import classes from "./TopicCard.module.less";

interface TopicCardProps extends TopicOption {
    checked?: boolean;
    onChange?: (id: string) => void;
}

export const TopicCard: FC<TopicCardProps> = ({ id, checked, label, description, onChange }) => {
    return (
        <div
            className={clsx(classes.topicToggle, checked && classes.topicToggleOn)}
            onClick={() => onChange && onChange(id)}
        >
            <Checkbox checked={checked} />
            <div>
                <div className={classes.topicLabel}>{label}</div>
                <div className={classes.topicDesc}>{description}</div>
            </div>
        </div>
    );
};
